var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "absolute z-20 -mt-3 mb-5 pb-6 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none card",
      attrs: {
        role: "menu",
        "aria-orientation": "vertical",
        "aria-labelledby": "menu-button",
        tabindex: "-1",
      },
    },
    [
      _c("div", { staticClass: "flex flex-col px-3 py-2" }, [
        _c(
          "div",
          {
            staticClass:
              "flex flex-row items-center content-center mt-4 px-3 pb-5",
          },
          [
            _c(
              "div",
              {},
              [
                _c("SchedulerItemAvatar", {
                  staticStyle: { width: "33px ,height:32px" },
                  attrs: {
                    avatar: _vm.employee.avatar,
                    title: _vm.employee.name,
                    small: false,
                  },
                }),
              ],
              1
            ),
            _c("span", { staticClass: "text ml-5" }, [
              _vm._v(_vm._s(_vm.employee.name)),
            ]),
          ]
        ),
        _c("span", { staticClass: "border-b-2 mx-4" }),
        _c(
          "div",
          {
            staticClass:
              "flex flex-row items-center content-center justify-between px-3 mt-4 pb-3",
          },
          [
            _c("span", { staticClass: "text-small" }, [_vm._v("Projects")]),
            _vm.projects
              ? _c(
                  "div",
                  { staticClass: "flex -space-x-3" },
                  [
                    _vm._l(_vm.firstProjects, function (project) {
                      return _c("CircleWithInitials", {
                        staticClass: "mr-2",
                        attrs: {
                          title: _vm.isManager
                            ? project.project.name
                            : project.name,
                          id: _vm.isManager
                            ? project.project.id
                            : _vm.projects.id,
                        },
                      })
                    }),
                    _vm.moreProjects > 0
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "flex items-center justify-center w-9 h-9 text-xs font-medium text-black bg-gray-400 border-2 border-white rounded-full hover:bg-gray-500 dark:border-gray-800",
                            staticStyle: { "background-color": "#9ADAF0" },
                            attrs: { href: "#" },
                          },
                          [_vm._v("+" + _vm._s(_vm.moreProjects))]
                        )
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
          ]
        ),
        _vm.isManager
          ? _c(
              "div",
              {
                staticClass:
                  "flex flex-row items-center content-center justify-between px-3 mt-3 pb-5",
              },
              [
                _c("span", { staticClass: "text-small" }, [
                  _vm._v("Contractors"),
                ]),
                _vm.contractors
                  ? _c(
                      "div",
                      { staticClass: "flex -space-x-3" },
                      [
                        _vm._l(_vm.firstContractors, function (contractor) {
                          return _c("SchedulerItemAvatar", {
                            staticStyle: { width: "33px ,height:32px" },
                            attrs: {
                              avatar: contractor.avatar,
                              title: contractor.name,
                              small: false,
                            },
                          })
                        }),
                        _vm.moreContractors > 0
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "flex items-center justify-center w-9 h-9 text-xs font-medium text-black bg-gray-400 border-2 border-white rounded-full hover:bg-gray-500 dark:border-gray-800",
                                staticStyle: { "background-color": "#9ADAF0" },
                                attrs: { href: "#" },
                              },
                              [_vm._v("+" + _vm._s(_vm.moreContractors))]
                            )
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
              ]
            )
          : _vm._e(),
        _c("span", { staticClass: "border-b-2 mx-4" }),
        _c("div", { staticClass: "mt-4 px-3" }, [
          _c("table", { staticClass: "table-fixed" }, [
            _c("tbody", { staticClass: "space-y-2" }, [
              _c(
                "tr",
                { staticClass: "leading-3 flex justify-between space-x-1" },
                [
                  _c("td", { staticClass: "text-left w-18" }, [
                    _vm._v("Title"),
                  ]),
                  _c("td", { staticClass: "text-small w-36" }, [
                    _vm._v(_vm._s(_vm.employee.title)),
                  ]),
                ]
              ),
              _c(
                "tr",
                { staticClass: "leading-3 flex justify-between space-x-1" },
                [
                  _c("td", { staticClass: "text-left w-18" }, [
                    _vm._v("Projects In Progress"),
                  ]),
                  _c("td", { staticClass: "text-small w-36" }, [
                    _vm._v(_vm._s(_vm.projectsInprogress)),
                  ]),
                ]
              ),
              _c(
                "tr",
                { staticClass: "leading-3 flex justify-between space-x-1" },
                [
                  _c("td", { staticClass: "text-left w-18" }, [
                    _vm._v("Projects Completed"),
                  ]),
                  _c("td", { staticClass: "text-small w-36" }, [
                    _vm._v(_vm._s(_vm.projectsCompleted)),
                  ]),
                ]
              ),
            ]),
          ]),
        ]),
        !_vm.isManager
          ? _c("span", { staticClass: "border-b-2 mx-4" })
          : _vm._e(),
        !_vm.isManager
          ? _c(
              "div",
              { staticClass: "mx-4 pt-2" },
              [
                _c("ItemChipsWithMore", {
                  staticClass: "w-full",
                  attrs: { items: _vm.skills, limit: 3 },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }